/**
 * NOTE: Move to masterDateSlice.ts
 */

import {createSlice} from '@reduxjs/toolkit'
import {RootState} from '../../store'
import {IFetchCustomerParams} from '../../api/modules/master-data/types'

export interface ICustomer {
  id: number
  customer_code: string
  title: string
  name: string
  name4: string
  erdate: string
  data_element_customer_status: number
  zvalue: string
  customer_account_group: string
  text: string
  va_registration_number: string
  masa_berlaku_npwp: string
  Masa_berlaku_surat_rekomendasi_dinas: string
  surat_rekomendasi_dinas: null | string
  masa_berlaku_SITU: string
  SITU: null | string
  masa_berlaku_SIUP: string
  SIUP: null | string
  TDP: null | string
  masa_berlaku_TDP: string
  company_type: string
  company_type_description: string
  nilai_asset: number
  revenue: number
  tahun_nilai_asset: number
  terms_of_payment_key: null
  created_at: string
  updated_at: string
  address: {
    id: string
    customer_code: string
    region_code: string
    city_code: string
    distrik_code: string
    street1: string
    street2: string
    address_type_normal: string
    address_type_billing: string
    no_telp: string
    no_fax: string
    created_at: string
    updated_at: string
  }
  contact: {
    id: string
    customer_code: string
    name1: string
    no_telp: string
    email: string
    created_at: string
    updated_at: string
  }
}

interface ILink {
  url: null | string
  label: string
  active: boolean
}

export interface IMaterialProductState {
  isLoading?: boolean
  error?: string
  customers?: Array<ICustomer>
  filter?: IFetchCustomerParams
  currentPage?: number
  pageSize?: 10 | 25 | 50 | 100 | 500
  links?: ILink[]
}

const initialState: IMaterialProductState = {
  isLoading: true,
  error: '',
  customers: [],
  filter: {
    company_type: '',
    customer_code: '',
    name: '',
    company_type_description: '',
    per_page: 25,
    customer_account_group: '',
    email: '',
    no_telp: '',
    street1: '',
    text: '',
  },
  currentPage: 1,
  /** @deprecated gunakan filter.per_page */
  pageSize: 10,
  links: [],
}

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setFilter: (state, action) => ({...state, filter: action.payload}),
    setCustomers: (state, action) => ({...state, customers: action.payload}),
    setIsLoading: (state, action) => ({...state, isLoading: action.payload}),
    setError: (state, action) => ({...state, error: action.payload}),
    setCurrentPage: (state, action) => ({...state, currentPage: action.payload}),
    /** @deprecated gunakan setFilter({...filter, per_page}) */
    setPageSize: (state, action) => ({...state, pageSize: action.payload}),
    setLinks: (state, action) => ({...state, links: action.payload}),
    resetFilter: (state) => {
      return {
        ...state,
        filter: initialState.filter,
        isLoading: true,
        error: '',
      }
    },
  },
})

export const {
  setFilter,
  setCustomers,
  setIsLoading,
  setError,
  setCurrentPage,
  setPageSize,
  setLinks,
  resetFilter,
} = customerSlice.actions

/** @deprecated gunakan filterSelector */
export const customerSelector = (state: RootState) => state.customerReducer

export default customerSlice.reducer
